import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  root: {
    width: '70vw',
  },
  message: {
    textAlign: 'center',
    margin: '30% auto auto auto',
    fontSize: '20px',
  },
}))

const ComingSoon = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <p className={classes.message}>We are building this for you.</p>
    </div>
  )
}

export default ComingSoon
